document.addEventListener("DOMContentLoaded", function () {
    const swiper = new Swiper(".swiperReviews", {
        // Optional parameters
        loop: true,
        pagination: { el: ".swiper-pagination" },
        navigation: {
            nextEl: ".swiper-btn-next",
            prevEl: ".swiper-btn-prev",
        },
    });
});
